export const convertDateAndTimeNow = date => {
	if (!date) return '-';

	const DateAndTime = new Date(date);

	return (
		DateAndTime.toLocaleDateString() +
		', ' +
		DateAndTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
	);
};
